module.exports = __webpack_public_path__ + "img/simon-min.3cf54e32.png";